var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[_c('router-link',{staticClass:"sidebar__logo-wrapper",attrs:{"to":{ name: 'home' }}},[_c('SVGlogo-stacked',{staticClass:"sidebar__logo",attrs:{"exact":""}})],1),_c('NavMain'),_c('FooterContact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }